import {TOption} from './TOption'

export const SIP_STATUS_OUTSTANDING: TOption[] = [
  {value: '1', label: 'Menunggu Persetujuan Level'},
  {value: '2', label: 'Revisi'},
  {value: '3', label: 'Proses PersetujuanLevel'},
  {value: '4', label: 'sent'},
  {value: '5', label: 'Diterima Anper'},
  {value: '6', label: 'Proses Realisasi Anper'},
  {value: '7', label: 'Proses Realisasi Customer'},
  {value: '8', label: 'Selesai'},
]
